module.exports = __webpack_public_path__ + "img/full4-min.5370e98d.png";